import { Guidance } from '@/shared/ui/guidance/guidance';

export function NotFound() {
  return <Guidance message="유효하지 않은 접근이에요" hint="전달받은 쿠폰 링크를 다시 확인해주세요" />;
}
